module.exports = __webpack_public_path__ + "img/Linux.a1100c64.png";